import { render, staticRenderFns } from "./FuelPrice.vue?vue&type=template&id=457daff0&scoped=true"
import script from "./FuelPrice.vue?vue&type=script&lang=ts"
export * from "./FuelPrice.vue?vue&type=script&lang=ts"
import style0 from "./FuelPrice.vue?vue&type=style&index=0&id=457daff0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457daff0",
  null
  
)

export default component.exports